import TemplateView from '../../TemplateView'
import {connect} from '../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    doesAllowRegularUsersToEditTaskStatuses,
    doesAllowUsersToSeeAllTT,
    doesHideAccountSettingsWhenDisabled,
    doesHideDetailsOnLockTT,
    doesHideNotAssignedTTDetails,
    doesShowUsernameInReports,
    doesTTMCanSeeAutoApproved,
    getTimeZoneGroupsList,
    getUserGroupsListWithDefault,
    getUsersForSeeAllTTFilter,
    getUsersList, isAllowRegularUsersToEditTasksStatusesCollapsed,
    isAllowUsersToSeeAllTTCollapsed,
    isHideAccountSettingsCollapsed,
    isHideDetailsOnLockTTCollapsed,
    isHideNotAssignedTTDetailsCollapsed,
    isShowUsernameInReportsCollapsed, isTtmCanSeeAutoApprovedCollapsed
} from './selectors'
import messageResource from '../../messageResource'
import {isTTAEnabled, isTZGEnabled, isUGREnabled, isWASEnabled} from '../../features/selectors'
import CustomCheckbox from '../../components/customCheckbox/CustomCheckbox'
import UsersFilter from './components/UsersFilter'
import SettingsInfoContent from './components/SettingsInfoContent'
import DARSetting from './components/DARSetting'
import ComponentsWrapper from './ComponentsWrapper'
import {
    setAllowRegularUsersToEditTasksStatuses,
    setAllowRegularUsersToEditTasksStatusesCollapsed,
    setAllowUsersToSeeAllTT,
    setAllowUsersToSeeAllTTCollapsed,
    setHideAccountSettingsCollapsed,
    setHideAccountSettingsWhenDisabled,
    setHideDetailsOnLockTT,
    setHideDetailsOnLockTTCollapsed,
    setHideNotAssignedTTDetails,
    setHideNotAssignedTTDetailsCollapsed,
    setShowUsernameInReports,
    setShowUsernameInReportsCollapsed,
    setTTMCanSeeAutoApproved,
    setTtmCanSeeAutoApprovedCollapsed,
    setUsersForSeeAllTTFilter
} from './actions'

export class DARSettingsSectionContainer extends TemplateView {
    constructor({
        setAllowUsersToSeeAllTT = () => {},
        setAllowRegularUsersToEditTasksStatuses = () => {},
        setShowUsernameInReports = () => {},
        setUsersForSeeAllTTFilter = () => {},
        setHideNotAssignedTTDetails = () => {},
        setHideDetailsOnLockTT = () => {},
        setHideAccountSettingsWhenDisabled = () => {},
        setTTMCanSeeAutoApproved = () => {},
        setAllowUsersToSeeAllTTCollapsed = () => {},
        setAllowRegularUsersToEditTasksStatusesCollapsed = () => {},
        setHideAccountSettingsCollapsed = () => {},
        setHideDetailsOnLockTTCollapsed = () => {},
        setHideNotAssignedTTDetailsCollapsed = () => {},
        setShowUsernameInReportsCollapsed = () => {},
        setTtmCanSeeAutoApprovedCollapsed = () => {},
    }) {
        super()

        this.state = {
            allowUsersToSeeAllTT: false,
            allowRegularUsersToEditTasksStatuses: true,

            usersForSeeAllTTFilter: {
                all: false,
                userIds: [],
                groupIds: [],
                groupType: null,
            },

            showUsernameInReports: false,
            hideNotAssignedTTDetails: false,
            hideDetailsOnLockTT: false,
            hideAccountSettingsWhenDisabled: false,
            ttmCanSeeAutoApproved: false,

            ttaEnabled: false,
            ugrEnabled: false,
            tzgEnabled: false,
            wasEnabled: false,

            users: [],
            userGroups: [],
            timeZoneGroups: [],

            allowUsersToSeeAllTTCollapsed: false,
            allowRegularUsersToEditTasksStatusesCollapsed: false,
            showUsernameInReportsCollapsed: false,
            hideNotAssignedTTDetailsCollapsed: false,
            hideDetailsOnLockTTCollapsed: false,
            hideAccountSettingsCollapsed: false,
            ttmCanSeeAutoApprovedCollapsed: false,
        }

        this.onStateChanged(() => {
            const newState = {
                userIds: this.state.usersForSeeAllTTFilter.userIds,
                groupIds: this.state.usersForSeeAllTTFilter.groupIds,
                all: this.state.usersForSeeAllTTFilter.all,
                groupType: this.state.usersForSeeAllTTFilter.groupType,
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                ugrEnabled: this.state.ugrEnabled,
                tzgEnabled: this.state.tzgEnabled,
            }

            this.usersSelector.setState(newState)
        })

        this.onStatePropertyChanged('allowUsersToSeeAllTT', () => {
            this.allowUsersToSeeAllTTChecbox.setState({
                checked: this.state.allowUsersToSeeAllTT,
            })

            this.usersSelector.setState({
                disabled: !this.state.allowUsersToSeeAllTT,
            })
        })

        this.onStatePropertyChanged('allowRegularUsersToEditTasksStatuses', allowRegularUsersToEditTasksStatuses => {
            this.allowRegularUsersToEditTasksStatusesCheckbox.setState({
                checked: allowRegularUsersToEditTasksStatuses,
            })
        })


        this.onStatePropertyChanged('showUsernameInReports', () => {
            this.showUsernameInReportsChecbox.setState({
                checked: this.state.showUsernameInReports,
            })
        })

        this.onStatePropertyChanged('hideNotAssignedTTDetails', () => {
            this.hideNotAssignedTTCheckbox.setState({
                checked: this.state.hideNotAssignedTTDetails,
            })
        })

        this.onStatePropertyChanged('hideDetailsOnLockTT', () => {
            this.hideLockTTDetailsCheckbox.setState({
                checked: this.state.hideDetailsOnLockTT
            })
        })

        this.onStatePropertyChanged('hideAccountSettingsWhenDisabled', () => {
            this.hideAccountSettingsCheckbox.setState({
                checked: this.state.hideAccountSettingsWhenDisabled
            })
        })

        this.onStatePropertyChanged('ttmCanSeeAutoApproved', () => {
            this.ttmCanManageAutoApprovedCheckbox.setState({
                checked: this.state.ttmCanSeeAutoApproved
            })
        })

        this.onStatePropertyChanged('ttaEnabled', () => {
            this.ttmCanManageAutoApprovedSetting.toggle(this.state.ttaEnabled)
        })

        this.onStatePropertyChanged('wasEnabled', () => {
            this.hideNotAssignedTtSetting.toggle(this.state.wasEnabled)
        })

        this.onStatePropertyChanged('allowUsersToSeeAllTTCollapsed', (collapsed) => {
            this.allowUsersToSeeAllTTSetting.setState({collapsed})
        })

        this.onStatePropertyChanged('allowRegularUsersToEditTasksStatusesCollapsed', (collapsed) => {
            this.allowRegularUsersToEditTasksStatusesSetting.setState({collapsed})
        })

        this.onStatePropertyChanged('showUsernameInReportsCollapsed', (collapsed) => {
            this.usernameSetting.setState({collapsed})
        })

        this.onStatePropertyChanged('hideNotAssignedTTDetailsCollapsed', (collapsed) => {
            this.hideNotAssignedTtSetting.setState({collapsed})
        })

        this.onStatePropertyChanged('hideDetailsOnLockTTCollapsed', (collapsed) => {
            this.hideLockTTDetailsSetting .setState({collapsed})
        })

        this.onStatePropertyChanged('hideAccountSettingsCollapsed', (collapsed) => {
            this.hideAccountDetailsSetting .setState({collapsed})
        })

        this.onStatePropertyChanged('ttmCanSeeAutoApprovedCollapsed', (collapsed) => {
            this.ttmCanManageAutoApprovedSetting .setState({collapsed})
        })

        this.actions = {
            setAllowUsersToSeeAllTT,
            setAllowRegularUsersToEditTasksStatuses,
            setAllowRegularUsersToEditTasksStatusesCollapsed,
            setShowUsernameInReports,
            setUsersForSeeAllTTFilter,
            setHideNotAssignedTTDetails,
            setHideDetailsOnLockTT,
            setHideAccountSettingsWhenDisabled,
            setTTMCanSeeAutoApproved,
            setAllowUsersToSeeAllTTCollapsed,
            setHideAccountSettingsCollapsed,
            setHideDetailsOnLockTTCollapsed,
            setHideNotAssignedTTDetailsCollapsed,
            setShowUsernameInReportsCollapsed,
            setTtmCanSeeAutoApprovedCollapsed,
        }
    }


    templateHtml() {
        return '<div class="darSettings_containers_darSettings collapsibleBlockContent">' +
               '</div>'
    }

    afterRender() {
        // users
        this.allowUsersToSeeAllTTChecbox = new CustomCheckbox({
            label: messageResource.getMessage('dar_settings.tt_limitations.allow_users_to_see_all_tt'),
            onChange: ({checked}) => this.actions.setAllowUsersToSeeAllTT(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })

        this.usersSelector = new UsersFilter({
            selectionCallback: result => {
                this.actions.setUsersForSeeAllTTFilter(result)
            },
        })
        this.allowUsersToSeeAllTTSetting = new DARSetting({
            headerContent: new ComponentsWrapper({
                components: [this.allowUsersToSeeAllTTChecbox,
                             this.usersSelector]
            }),
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'dar_settings.tt_limitations.allow_users_to_see_all_tt.if_enabled_note',
                enabledImageBottomDescKey: 'dar_settings.tt_limitations.allow_users_to_see_all_tt.if_enabled_img_desc',
                disabledTextKey:'dar_settings.tt_limitations.allow_users_to_see_all_tt.if_disabled_note',
                disabledImageBottomDescKey: 'dar_settings.tt_limitations.allow_users_to_see_all_tt.if_disabled_img_desc',
            }),
            extraClass: "allowUsersToSeeAllTTSetting",
            onCollapseChanged: this.actions.setAllowUsersToSeeAllTTCollapsed,
        }).init(this.$el)

        //allow regular users to edit task's statuses
        this.allowRegularUsersToEditTasksStatusesCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('dar_settings.tt_limitations.allow_regular_users_to_edit_task_statuses'),
            onChange: ({checked}) => this.actions.setAllowRegularUsersToEditTasksStatuses(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })

        this.allowRegularUsersToEditTasksStatusesSetting = new DARSetting({
            headerContent: new ComponentsWrapper({
                components: [this.allowRegularUsersToEditTasksStatusesCheckbox]
            }),
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'dar_settings.tt_limitations.allow_regular_users_to_edit_task_statuses.if_enabled_note',
                enabledImageBottomDescKey: 'dar_settings.tt_limitations.allow_regular_users_to_edit_task_statuses.if_enabled_img_desc',
                disabledTextKey:'dar_settings.tt_limitations.allow_regular_users_to_edit_task_statuses.if_disabled_note',
                disabledImageBottomDescKey: 'dar_settings.tt_limitations.allow_regular_users_to_edit_task_statuses.if_disabled_img_desc',
            }),
            extraClass: "allowRegularUsersToEditTasksStatusesSetting",
            onCollapseChanged: this.actions.setAllowRegularUsersToEditTasksStatusesCollapsed,
        }).init(this.$el)

        // usernames in reports
        this.showUsernameInReportsChecbox = new CustomCheckbox({
            label: messageResource.getMessage('dar_settings.tt_limitations.show_usernames_in_reports'),
            onChange: ({checked}) => this.actions.setShowUsernameInReports(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })
        this.usernameSetting = new DARSetting({
            headerContent: this.showUsernameInReportsChecbox,
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'dar_settings.tt_limitations.show_usernames_in_reports.if_enabled_note',
                enabledImageTopDescKey: 'dar_settings.tt_limitations.show_usernames_in_reports.if_enabled_img_desc',
                disabledTextKey:'dar_settings.tt_limitations.show_usernames_in_reports.if_disabled_note',
                disabledImageTopDescKey: 'dar_settings.tt_limitations.show_usernames_in_reports.if_disabled_img_desc',
            }),
            extraClass: "usernameSetting",
            onCollapseChanged: this.actions.setShowUsernameInReportsCollapsed,
        }).init(this.$el)

        // lock tt
        this.hideLockTTDetailsCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('general_settings.tt_limitations_section.hide_details_on_lock_tt'),
            onChange: ({checked}) => this.actions.setHideDetailsOnLockTT(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })
        this.hideLockTTDetailsSetting = new DARSetting({
            headerContent: this.hideLockTTDetailsCheckbox,
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'general_settings.tt_limitations_section.hide_details_on_lock_tt_note',
                enabledImageBottomDescKey: 'dar_settings.tt_limitations.hide_details_on_lock_tt.if_enabled_img_desc',
                disabledTextKey:'general_settings.tt_limitations_section.hide_details_on_lock_tt_note.disabled',
                disabledImageBottomDescKey: 'dar_settings.tt_limitations.hide_details_on_lock_tt.if_disabled_img_desc',
            }),
            extraClass: "hideLockTTDetailsSetting",
            onCollapseChanged: this.actions.setHideDetailsOnLockTTCollapsed,
        }).init(this.$el)

        // assigned tt details
        this.hideNotAssignedTTCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('general_settings.tt_limitations_section.hide_time_track_details'),
            onChange: ({checked}) => this.actions.setHideNotAssignedTTDetails(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })
        this.hideNotAssignedTtSetting = new DARSetting({
            headerContent: this.hideNotAssignedTTCheckbox,
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'general_settings.tt_limitations_section.hide_tt_note',
                disabledTextKey:'general_settings.tt_limitations_section.hide_tt_note.disabled',
            }),
            extraClass: "hideNotAssignedTTSetting",
            onCollapseChanged: this.actions.setHideNotAssignedTTDetailsCollapsed,
        }).init(this.$el)

        // account settings
        this.hideAccountSettingsCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('general_settings.tt_limitations_section.hide_account_settings'),
            onChange: ({checked}) => this.actions.setHideAccountSettingsWhenDisabled(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })
        this.hideAccountDetailsSetting = new DARSetting({
            headerContent: this.hideAccountSettingsCheckbox,
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'general_settings.tt_limitations_section.hide_account_settings_note',
                enabledImageBottomDescKey: 'dar_settings.tt_limitations.hide_account_settings.if_enabled_img_desc',
                disabledTextKey:'general_settings.tt_limitations_section.hide_account_settings_note.disabled',
                disabledImageBottomDescKey: 'dar_settings.tt_limitations.hide_account_settings.if_disabled_img_desc',
            }),
            extraClass: "hideAccountSetting",
            onCollapseChanged: this.actions.setHideAccountSettingsCollapsed,
        }).init(this.$el)

        // manage auto approved
        this.ttmCanManageAutoApprovedCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('general_settings.ttm_can_see_auto_approved'),
            onChange: ({checked}) => this.actions.setTTMCanSeeAutoApproved(checked),
            containerAdditionalClass: 'checkboxContainer',
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
        })
        this.ttmCanManageAutoApprovedSetting = new DARSetting({
            headerContent: this.ttmCanManageAutoApprovedCheckbox,
            descriptionContent: new SettingsInfoContent({
                enabledTextKey:'general_settings.ttm_can_see_auto_approved_note',
                disabledTextKey:'general_settings.ttm_can_see_auto_approved_note.disabled',
            }),
            extraClass: "ttmCanManageAutoApprovedSetting",
            onCollapseChanged: this.actions.setTtmCanSeeAutoApprovedCollapsed,
        }).init(this.$el)
    }
}

export default connect(
    (state) => ({
        allowUsersToSeeAllTT: doesAllowUsersToSeeAllTT(state),
        allowRegularUsersToEditTasksStatuses: doesAllowRegularUsersToEditTaskStatuses(state),
        showUsernameInReports: doesShowUsernameInReports(state),
        usersForSeeAllTTFilter: getUsersForSeeAllTTFilter(state),
        hideNotAssignedTTDetails: doesHideNotAssignedTTDetails(state),
        hideDetailsOnLockTT: doesHideDetailsOnLockTT(state),
        hideAccountSettingsWhenDisabled: doesHideAccountSettingsWhenDisabled(state),
        ttmCanSeeAutoApproved: doesTTMCanSeeAutoApproved(state),
        ttaEnabled: isTTAEnabled(state),
        ugrEnabled: isUGREnabled(state),
        tzgEnabled: isTZGEnabled(state),
        wasEnabled: isWASEnabled(state),
        userGroups: getUserGroupsListWithDefault(state),
        timeZoneGroups: getTimeZoneGroupsList(state),
        users: getUsersList(state),
        allowUsersToSeeAllTTCollapsed: isAllowUsersToSeeAllTTCollapsed(state),
        allowRegularUsersToEditTasksStatusesCollapsed: isAllowRegularUsersToEditTasksStatusesCollapsed(state),
        showUsernameInReportsCollapsed: isShowUsernameInReportsCollapsed(state),
        hideNotAssignedTTDetailsCollapsed: isHideNotAssignedTTDetailsCollapsed(state),
        hideDetailsOnLockTTCollapsed: isHideDetailsOnLockTTCollapsed(state),
        hideAccountSettingsCollapsed: isHideAccountSettingsCollapsed(state),
        ttmCanSeeAutoApprovedCollapsed: isTtmCanSeeAutoApprovedCollapsed(state),
    }),
    (dispatch) => ({
        setAllowUsersToSeeAllTT: bindActionCreators(setAllowUsersToSeeAllTT, dispatch),
        setAllowRegularUsersToEditTasksStatuses: bindActionCreators(setAllowRegularUsersToEditTasksStatuses, dispatch),
        setShowUsernameInReports: bindActionCreators(setShowUsernameInReports, dispatch),
        setUsersForSeeAllTTFilter: bindActionCreators(setUsersForSeeAllTTFilter, dispatch),
        setHideNotAssignedTTDetails: bindActionCreators(setHideNotAssignedTTDetails, dispatch),
        setHideDetailsOnLockTT: bindActionCreators(setHideDetailsOnLockTT, dispatch),
        setHideAccountSettingsWhenDisabled: bindActionCreators(setHideAccountSettingsWhenDisabled, dispatch),
        setTTMCanSeeAutoApproved: bindActionCreators(setTTMCanSeeAutoApproved, dispatch),
        setAllowUsersToSeeAllTTCollapsed: bindActionCreators(setAllowUsersToSeeAllTTCollapsed, dispatch),
        setAllowRegularUsersToEditTasksStatusesCollapsed: bindActionCreators(setAllowRegularUsersToEditTasksStatusesCollapsed, dispatch),
        setShowUsernameInReportsCollapsed: bindActionCreators(setShowUsernameInReportsCollapsed, dispatch),
        setHideNotAssignedTTDetailsCollapsed: bindActionCreators(setHideNotAssignedTTDetailsCollapsed, dispatch),
        setHideDetailsOnLockTTCollapsed: bindActionCreators(setHideDetailsOnLockTTCollapsed, dispatch),
        setHideAccountSettingsCollapsed: bindActionCreators(setHideAccountSettingsCollapsed, dispatch),
        setTtmCanSeeAutoApprovedCollapsed: bindActionCreators(setTtmCanSeeAutoApprovedCollapsed, dispatch),
    })
)(DARSettingsSectionContainer)



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/DARSettingsSectionContainer.js